export default __webpack_public_path__ + "static/media/ABOUT.8c45ef73.svg";